import { FC, useState } from 'react';
import { Form } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { UserForgotPasswordFormValuesType, UserForgotPasswordProcessPayloadType } from '@edikk-edikk/country-frontend';
import { ReCaptchaErrorForNewUI, useReCaptchaContext } from '@edikk-edikk/recaptcha';
import { ForgotPasswordFormDescription, ForgotPasswordFormSubmit } from '#userForgotPasswod/components';
import { FieldInput, FieldInputVariant } from '#components/form';
import authFormCss from '../../../../assets/auth-form.module.scss';
import { useApi } from '#hooks/use-api';
import { Text } from '#components/text';
import { useVariantByStyle } from '#hooks/use-variant-by-style';

const ForgotPasswordForm: FC = () => {
  const api = useApi();
  const [process] = api.getApiUserForgotPassword().useLazyProcessQuery();
  const [isProcessed, setIsProcessed] = useState<boolean>(false);
  const { process: reCaptchaProcess } = useReCaptchaContext();
  const variantByStyle = useVariantByStyle();

  const handlerSubmit = async (
    values: UserForgotPasswordFormValuesType,
  ): Promise<void|object> => {
    const reCaptchaToken = await reCaptchaProcess();
    const data: UserForgotPasswordProcessPayloadType = {
      email: values.email,
      reCaptcha: reCaptchaToken,
    };
    const response = await process(data).unwrap();

    if ('formErrors' in response) {
      return Promise.resolve(response.formErrors);
    }

    setIsProcessed(true);

    return Promise.resolve();
  };

  if (isProcessed) {
    return (
      <Text colorGray fontSizeSm textAlignCenter>
        <FormattedMessage defaultMessage="Email has been sent" />
      </Text>
    );
  }

  return (
    <Form<UserForgotPasswordFormValuesType>
      onSubmit={handlerSubmit}
      render={({ handleSubmit }) => (
        <form className={authFormCss.authForm} onSubmit={handleSubmit}>
          <ForgotPasswordFormDescription />
          <FieldInput
            name="email"
            id="field-email"
            label={<FormattedMessage defaultMessage="Email" />}
            isRequired
            variant={variantByStyle(FieldInputVariant.lightGray34Percent, FieldInputVariant.wispPink)}
          />
          <ReCaptchaErrorForNewUI />
          <ForgotPasswordFormSubmit />
        </form>
      )}
    />
  );
};

export { ForgotPasswordForm };
